export default "__VITE_ASSET__CeqPe9$Y__"